import {createFeatureSelector, createSelector} from "@ngrx/store";
import {fiusFeatureKey, FiusState} from "../reducers/fius.reducer";

const fiusFeatureState = createFeatureSelector<FiusState>(fiusFeatureKey);

export const getFius = createSelector(
  fiusFeatureState,
  state => state.fius ?? []
);

export const getTotalRecords = createSelector(
  fiusFeatureState,
  state => state.totalRecords ?? 0
);

export const getSelectedFiu = createSelector(
  fiusFeatureState,
  state => state.selectedFiu ?? null
)

export const getFiuStatuses = createSelector(
  fiusFeatureState,
  state => state.fiuStatuses ?? []
);

export const getFiuList= createSelector(
  fiusFeatureState,
  state => state.fiuList ?? []
)

